import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/hydraulic-power-calculator',
  component: () => import('../../routes/HydraulicPowerCalculator.svelte'),
  card: {
    id: 'hydraulic-power-calculator',
    title: 'Hydraulic Power',
    description: 'Calculate hydraulic horsepower from PSI and GPM, or solve for required flow rate and pressure.',
    icon: 'hydraulic_power',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-blue-600',
    href: '/hydraulic-power-calculator',
    category: 'Physics & Science',
  },
  seo: {
    title: 'Hydraulic Power Calculator – Calculate Hydraulic Horsepower (HP) from PSI & GPM',
    description:
      'Free hydraulic power calculator to find hydraulic horsepower using HP = (PSI × GPM) / 1714. Also converts HP to Watts and solves for required flow rate or pressure.',
  },
};

export default meta;
